export const defaultFilters = {
  // source selection
  sources: ['local', 'internet'], // 'local' = registered manufacturers; 'internet' = global fetch

  colors: [],
  price: [0, 3000],
  fast: false,
  available: false,
  category: '',
  brand: '',
  mountings: [],
  shapes: [],
  adjustable: false,
  wallMounted: false,
  base: false,
  rgbw: false,
  tunableWhite: false,
  controls: [],
  power: [5, 300],
  voltage: [],
  heads: [1, 200],
  lumens: [50, 30000],
  efficiency: [], // ['gt100','gt120']
};

export function textMatch(p, q) {
  if (!q) return true;
  const hay = `${p.name} ${p.subtitle} ${p.brand} ${p.category} ${p.model}`.toLowerCase();
  return hay.includes(q.toLowerCase());
}

const hasNum = (v) => typeof v === 'number' && Number.isFinite(v);

export function applyAllFilters(items, f, query) {
  const chosenSources = Array.isArray(f.sources) && f.sources.length ? f.sources : ['local', 'internet'];

  return items.filter((p) => {
    // source gate first
    if (!chosenSources.includes(p.source)) return false;

    if (!textMatch(p, query)) return false;

    // price
    if (typeof p.price === 'number') {
      if (p.price < f.price[0] || p.price > f.price[1]) return false;
    }

    // speed/availability
    if (f.fast && !p.fastShipping) return false;
    if (f.available && !p.available) return false;

    // color
    if (f.colors.length && (!p.color || !f.colors.includes(p.color))) return false;

    // category/brand
    if (f.category && p.category !== f.category) return false;
    if (f.brand && p.brand !== f.brand) return false;

    // The checks below are **local-only attributes**. If the product doesn't have them
    // (e.g., internet items), we simply skip those checks to avoid clashes.

    // mounting
    if (f.mountings.length && Array.isArray(p.mountings)) {
      if (!f.mountings.some((m) => p.mountings.includes(m))) return false;
    }

    // shape
    if (f.shapes.length && p.shape) {
      if (!f.shapes.includes(p.shape)) return false;
    }

    // booleans
    if (f.adjustable && p.adjustable === false) return false;
    if (f.wallMounted && p.wallMounted === false) return false;
    if (f.base && p.baseIncluded === false) return false;
    if (f.rgbw && p.rgbw === false) return false;
    if (f.tunableWhite && p.tunableWhite === false) return false;

    // controls
    if (f.controls.length && Array.isArray(p.controls)) {
      if (!f.controls.some((c) => p.controls.includes(c))) return false;
    }

    // power / heads / lumens
    if (hasNum(p.power) && (p.power < f.power[0] || p.power > f.power[1])) return false;
    if (hasNum(p.heads) && (p.heads < f.heads[0] || p.heads > f.heads[1])) return false;
    if (hasNum(p.lumens) && (p.lumens < f.lumens[0] || p.lumens > f.lumens[1])) return false;

    // efficiency chips
    if (f.efficiency.includes('gt100') && hasNum(p.efficiency) && !(p.efficiency >= 100)) return false;
    if (f.efficiency.includes('gt120') && hasNum(p.efficiency) && !(p.efficiency >= 120)) return false;

    // voltage
    if (f.voltage.length && p.voltage) {
      if (!f.voltage.includes(p.voltage)) return false;
    }

    return true;
  });
}
